import * as React from 'react';
import { useNavigate } from "react-router-dom";
import { Form, Field, FormElement } from '@progress/kendo-react-form';
import { Button } from '@progress/kendo-react-buttons';
import { Input } from './../components/form/Input';
import { MaskedTextBox } from './../components/form/MaskedTextBox';
import { Upload } from './../components/form/Upload';
import { RadioGroup } from './../components/form/RadioGroup';
import { Switch } from './../components/form/Switch';
import { AppContext } from './../AppContext'
import { teams } from './../resources/teams';

import { requiredValidator, emailValidator, phoneValidator} from './../validators'

const teamsData = teams.map(team => ({
    value: team.teamID,
    label: team.teamName
}));

const Profile = () => {
    const { onProfileChange, ...formValues } = React.useContext(AppContext);
    const history = useNavigate();

    const onSubmit = React.useCallback(
        (dataItem) => {
            onProfileChange({ dataItem });
            history('/');
        },
        [onProfileChange, history]
    );

    const onCancelClick = React.useCallback(
        () => {
            history('/users');
        },
        [history]
    );

    return (
        <div id="Profile" className="profile-page main-content">
            <div className="card-container">
                <div className="card-component">
                    <Form
                        onSubmit={onSubmit}
                        initialValues={{
                            ...formValues
                        }}
                        render={(formRenderProps) => (
                            <FormElement horizontal={true} style={{ maxWidth: 700 }}>
                                <Field
                                    id={'avatar'}
                                    name={'avatar'}
                                    label={''}
                                    validator={requiredValidator}
                                    component={Upload}
                                />
                                <Field
                                    id={'firstName'}
                                    name={'firstName'}
                                    label={'Vorname'}
                                    validator={requiredValidator}
                                    component={Input}
                                />
                                <Field
                                    id={'lastName'}
                                    name={'lastName'}
                                    label={'Nachname'}
                                    validator={requiredValidator}
                                    component={Input}
                                />
                                <Field
                                    id={'email'}
                                    name={'email'}
                                    type={'email'}
                                    placeholder={'e.g.: peter@gmail.com'}
                                    label={'E-Mail'}
                                    validator={emailValidator}
                                    component={Input}
                                />
                                <Field
                                    id={'phoneNumber'}
                                    name={'phoneNumber'}
                                    label={'Telefonnummer'}
                                    mask={'(+9) 0000-000-00-00'}
                                    validator={phoneValidator}
                                    component={MaskedTextBox}
                                />
                                <Field
                                    labelId={'isInPublicDirectoryLabel'}
                                    name={'isInPublicDirectory'}
                                    label={'Benutzer aktiv'}
                                    component={Switch}
                                />
                                <Field
                                    id={'password'}
                                    name={'password'}
                                    type={'password'}
                                    label={'Passwort'}
                                    validator={requiredValidator}
                                    component={Input}
                                />
                                <Field
                                    labelId={'teamlabel'}
                                    name={'teamId'}
                                    layout={'horizontal'}
                                    label={'Team'}
                                    component={RadioGroup}
                                    data={teamsData}
                                />
                                <hr />
                                <div className={'k-form-buttons'}>
                                    <Button onClick={onCancelClick}>
                                        Abbrechen
                                    </Button>
                                    <Button
                                        themeColor={"primary"}
                                        type={'submit'}
                                        disabled={!formRenderProps.allowSubmit}
                                    >
                                        Speichern
                                    </Button>
                                </div>
                            </FormElement>
                        )}
                    />
                </div>
            </div>
        </div>
    );
}

export default Profile;
